<template>
  <v-card>
    <v-card-title> GALLARY </v-card-title>
    <v-card-text>
      <v-container fluid class="px-0">
        <v-row>
          <v-col
            v-for="picture in pictures"
            :key="picture.id"
            class="d-flex child-flex"
            cols="4"
          >
            <v-card
              flat
              tile
              class="d-flex"
              @mouseover="overlayPictureId = picture.id"
              @mouseleave="overlayPictureId = null"
            >
              <v-img
                :src="getFilePath(picture.file.middle.url)"
                aspect-ratio="1"
                class="grey lighten-2"
                max-width="300"
                max-height="200"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular indeterminate color="grey lighten-5" />
                  </v-row>
                </template>
              </v-img>
              <v-overlay absolute :value="overlayPictureId === picture.id">
                <v-btn color="primary" @click="selectPicture(picture)">
                  SELECT
                </v-btn>
              </v-overlay>
            </v-card>
          </v-col>
        </v-row>
        <infinite-loading @infinite="infiniteHandler">
          <template v-slot:no-more>
            <v-chip class="mt-10" label color="teal" text-color="white">
              <v-avatar left>
                <v-icon>mdi-checkbox-marked-circle</v-icon>
              </v-avatar>
              画像が全て表示されました
            </v-chip>
          </template>
          <template v-slot:no-results>
            <v-chip class="mt-10" label large color="amber" text-color="white">
              <v-avatar left>
                <v-icon>mdi-close-circle</v-icon>
              </v-avatar>
              画像が見つかりませんでした
            </v-chip>
          </template>
        </infinite-loading>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from 'axios'
import InfiniteLoading from 'vue-infinite-loading'
import imageUtilsMixin from '@/mixins/image_utils'

export default {
  name: 'PictureGallary',
  components: {
    InfiniteLoading
  },
  mixins: [imageUtilsMixin],
  props: {
    pictureGallary: {
      type: Boolean,
      required: true
    }
  },
  data: () => {
    return {
      page: 1,
      overlayPictureId: null,
      pictures: []
    }
  },
  methods: {
    infiniteHandler ($state) {
      axios
        .get('/api/pictures', {
          params: {
            page: this.page
          }
        })
        .then(({ data }) => {
          const fetchedPictures = data.data
          if (fetchedPictures.length) {
            this.page++
            for (const i in fetchedPictures) {
              const picture = fetchedPictures[i].attributes
              this.pictures.push(picture)
            }
            $state.loaded()
          } else {
            $state.complete()
          }
        })
    },
    selectPicture (picture) {
      this.$emit('select-picture', picture)
    }
  }
}
</script>

<style scoped></style>
